import React from "react";
import ReimbursementTransactionsViewAll from "../../containers/Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import LargePopupRedirect from "../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../assets/Icons";

const ReimbursementTxnViewAllPopup = ({
  closeReimburseTxnDetailsModal,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  HistoryPopup,
}) => {
  return (
    <div>
      <LargePopupRedirect
        headerTitle="Transaction history"
        headersubtext="All transactions related to the reimbursement are listed below."
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={() => closeReimburseTxnDetailsModal()}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <ReimbursementTransactionsViewAll
          type={type}
          TxnHistoryid={TxnHistoryid}
          TxnHistoryAccountName={TxnHistoryAccountName}
          categoryName={categoryName}
          closeReimburseTxnDetailsModal={closeReimburseTxnDetailsModal}
          HistoryPopup={HistoryPopup}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default ReimbursementTxnViewAllPopup;
